import { Switch, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Home } from "./components/Home";
import { About } from "./components/About";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { css } from "@emotion/react";
import ClockLoader from "react-spinners/ClockLoader";
import { useState } from "react";

const override = css`
  display: block;
  margin: 20% auto;
  @media screen and (max-width: 768px) {
    margin: 75% auto;
  }
`;

function App() {
  const [isLoading, setIsLoading] = useState(true);
  setTimeout(() => {
    setIsLoading(false);
  }, 2000);
  return (
    <>
      {isLoading ? (
        <ClockLoader
          color={"#ffffff"}
          loading={isLoading}
          css={override}
          size={150}
        />
      ) : (
        <>
          <Navbar />
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/about">
              <About />
            </Route>
            <Route path="/skills">
              <Skills />
            </Route>
            <Route path="/projects">
              <Projects />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
          </Switch>
        </>
      )}
    </>
  );
}

export default App;
